/**
 * Short label for a failed bridge step on the boot breadcrumb line: the error
 * class, or its message when the class is a bare `Error` (bifrost's
 * `RPC call timeout`). The line is capped, so this stays one short token.
 */
export function describeFailure(error: unknown): string {
  if (!(error instanceof Error)) return typeof error
  return (error.name === 'Error' ? error.message : error.name).replace(
    /\s+/g,
    '_',
  )
}
